import {
  xlength,
  ylength,
  autoRotationInterval,
  zoomMode,
  image,
  app,
  viewer,
  isSmothZoom,
  changeZoom,
  imgWidth,
  imgHeight,
  mouseSpeed
} from "./variable";
import {
  changeDown,
  changeUp,
  changeLeft,
  changeRight,
  toggleAutorotation
} from "./changeView";
import {
  zoom,
  getZoomScale
} from "./zoom";

let isOn = true;
let isCliked = false;

let widthInterval;
let heightInterval;
let startX;
let startY;
let lastPositionX;
let lastPositionY;
let transformX = 0;
let transformY = 0;
let isZoomMode = false;
let canvas;

const init = () => {
  canvas.addEventListener("mousemove", (e) => {
    if (isCliked && isOn) {
      if (zoomMode) {
        let imageBoundRect = image.getClientRects()[0];
        const nextTransformX = (lastPositionX + e.clientX - startX) * 2;
        const nextTransformY = (lastPositionY + e.clientY - startY) * 2;
        if (
          -(nextTransformX - app.clientWidth) < imageBoundRect.width &&
          nextTransformX + app.clientWidth < imageBoundRect.width
        ) {
          transformX = lastPositionX + e.clientX - startX;
          image.style.left = transformX + "px";
        }
        if (
          -(nextTransformY - app.clientHeight) < imageBoundRect.height &&
          nextTransformY + app.clientHeight < imageBoundRect.height
        ) {
          transformY = lastPositionY + e.clientY - startY;
          image.style.top = transformY + "px";
        }
      } else {
        let currentX = e.clientX;
        let currentY = e.clientY;
        if (Math.abs(startX - currentX) >= widthInterval) {
          if (startX - currentX > 0) {
            changeLeft();
          } else {
            changeRight();
          }
          startX = currentX;
        }
        if (Math.abs(startY - currentY) >= heightInterval) {
          if (startY - currentY > 0) {
            changeUp();
          } else {
            changeDown();
          }
          startY = currentY;
        }
      }
    }
    if (!isCliked) {
      lastPositionX = transformX;
      lastPositionY = transformY;
    }
  });
  canvas.addEventListener("mousedown", (e) => {
    if (autoRotationInterval) {
      toggleAutorotation();
    }
    isCliked = true;
    if (isOn) {
      startX = e.clientX;
      startY = e.clientY;
      let speedIndicator = mouseSpeed < 0 ? 0 : mouseSpeed;
      speedIndicator = mouseSpeed > 100 ? 100 : mouseSpeed;
      switch (true) {
        case (speedIndicator >= 0 && speedIndicator < 50):
          speedIndicator = (0.01 * speedIndicator) + 0.5;
          break;
        case (speedIndicator > 50 && speedIndicator <= 100):
          speedIndicator = (speedIndicator * 2) / 100;
          break;
        default:
          speedIndicator = 1;
      }
      widthInterval = Math.round((canvas.clientWidth / (xlength * 1.5)) / speedIndicator);
      heightInterval = Math.round((canvas.clientHeight / (ylength * 1.5)) / speedIndicator);
    }
  });
  canvas.addEventListener("mouseup", (e) => {
    isCliked = false;
  });
  canvas.addEventListener("mouseleave", (e) => {
    isOn = false;
    isCliked = false;
  });
  canvas.addEventListener("mouseenter", (e) => {
    isOn = true;
  });
  window.addEventListener("wheel", (e) => {
    if (!isSmothZoom) {
      if (viewer.viewport.getZoom(true) <= 1.3)
        if (e.deltaY < 0) {
          canvas.style.display = "none";
          changeZoom(true);
          isZoomMode = true;
          viewer.viewport.zoomTo(viewer.viewport.getZoom(true) + 0.5);
        } else {

          changeZoom(false);
          canvas.style.display = "initial";
          isZoomMode = false;
          viewer.viewport.zoomTo(1);
          viewer.viewport.fitHorizontally();
          viewer.viewport.fitVertically();
        }
    } else {
      if (e.deltaY < 0) {
        if (getZoomScale() > 1) {
          canvas.style.display = "none";
          changeZoom(true);
          isZoomMode = true;

        }
        zoom('in');
      } else {
        if (getZoomScale() <= 1) {
          changeZoom(false);
          canvas.style.display = "initial";
          isZoomMode = false;

        }
        zoom('out');
      }
    }
  });
  window.addEventListener("resize", (e) => {

    const image = document.querySelector("#image");
    const buttons = document.querySelector(".buttons")
    const imageWidth = (((imgWidth / imgHeight) * window.innerHeight) / window.innerWidth * 100).toFixed(2);
    image.style.width = imageWidth + "%";
    buttons.style.left = (window.innerWidth / 2 - 150) + "px";
    canvas.style.width = imageWidth + "%";
    image.style.left = (100 - imageWidth) / 2 + "%";
    canvas.style.left = (100 - imageWidth) / 2 + "%";
  })
};
let canvasInterval = setInterval(() => {
  canvas = document.querySelector(".canvas");

  if (canvas != null) {
    clearInterval(canvasInterval);
    init();
  }
}, 200);

if (!isSmothZoom) {
  let imageInterval = setInterval(() => {
    let app = document.querySelector(".app");

    if (app != null) {
      clearInterval(imageInterval);
      app.addEventListener("mousemove", (e) => {
        if (viewer.viewport.getBounds().width !== 1) {
          if (!isZoomMode) {
            canvas.style.display = "none";
            changeZoom(true);
            isZoomMode = true;
          }
        } else {
          if (isZoomMode) {
            changeZoom(false);
            canvas.style.display = "initial";
            isZoomMode = false;
          }
        }
      });
    }
  }, 200);
}